export const AutomationImageParams = {
    img1:"Automation__Auto-Advanced.png",
    img2:"Automation__Auto-Beginner.png",
    img3:"Automation__Auto-Intermediate.png"
};

export const BackendImageParams = {
    img1:"Backend__Backend-Advanced.png",
    img2:"Backend__Backend-Beginner.png",
    img3:"Backend__Backend-Intermediate.png"
};

export const DataEngineeringImageParams = {
    img1:"DataEngineering__data-advanced-info.png",
    img2:"DataEngineering__data-foundation-info-new.png",
    img3:"DataEngineering__data-foundation-info.png",
    img4:"DataEngineering__data-intermediate-info.png"
};

export const FullStackImageParams = {
    img1:"FullStack__Advanced.png",
    img2:"FullStack__Beginner.png",
    img3:"FullStack__Full Stack Engineering - Beginner.png",
    img4:"FullStack__Intermediate.png"
};

export const HomeImagesParams = {
    img1:"Home__Acc_GT_Dimensional_RGB.png",//Footer
    img2:"Home__Ananya.png",//TestimonialsData.json
    img4:"Home__Approach-infographics-latest-oney.png",//FrameworksTabs
    img8:"Home__Chirag.png" ,//TestimonialsData.json
    img12:"Home__Framework-infographics-latest-one.png",//FrameworksTabs
    img19:"Home__karthi.png",//TestimonialsData.json
    img21:"Home__shail.png",//TestimonialsData.json
    img22:"Home__Profeciency-infographics-latest.png",
    img23:"Domains__elevate-info-new-final.png",
};

export const SystemImagesParams = {
    img1:"System__Advanced.png",
    img2:"System__Beginner.png",
    img3:"System__Intermediate.png"
};

export const WebImagesParams = {
    img1:"Web__Advanced.png",
    img2:"Web__Beginner.png",
    img3:"Web__Intermediate.png"
};

export const SponsorsImagesParams = {
    img1:"Sponsors__core-team-pic1.png",
    img2:"Sponsors__core-team-pic2.png",
    img3:"Sponsors__core-team-pic3.png",
    img4:"Sponsors__leader-pic1.png",
    img5:"Sponsors__leader-pic2.png"
};

export const LogoImagesParams ={
    img1:"Acc_Logo_Black_Purple_RGB.png",
    img2:"Home__Acc_GT_Dimensional_RGB.png",
    img3:"Home__home-banner-new.png"
}